import React from 'react'
import CollectorContext from '../contexts/CollectorContext'

export default function useResource () {
  return React.useContext(CollectorContext)
}
